interface EmptyStateProps {
  title: string;
  description: string;
}

export const EmptyState = ({ title, description }: EmptyStateProps) => (
  <div className="flex h-[240px] flex-col items-center justify-center gap-2 text-center text-system-white40">
    <div className="text-sm">{title}</div>
    <div className="max-w-[260px] text-xs leading-5">{description}</div>
  </div>
);
